import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Hekima4";

const HekimaPhase4 = () => {
  const projectId = "PRJ00063";
  const title = "Hekima Phase 4";

  const mapConfig = {
    minZoom: 18,
    zoom: 19,
    bounds: [
      [40.65331, -74.00154],
      [40.64421, -73.98772],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links were empty in legacy component
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default HekimaPhase4;
